import { render, staticRenderFns } from "./sendOrder.vue?vue&type=template&id=208c0195&scoped=true&"
import script from "./sendOrder.vue?vue&type=script&lang=js&"
export * from "./sendOrder.vue?vue&type=script&lang=js&"
import style0 from "./sendOrder.vue?vue&type=style&index=0&id=208c0195&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208c0195",
  null
  
)

export default component.exports